<ng-container *ngIf="!showProductNotFound; else productNotFound">
  <div class="container">
    <div id="tabs-primary" class="row">
      <div class="col-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
      </div>
    </div>

    <div id="siteContent" class="row">
      <div id="info" class="col-12 col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <h2 *ngIf="productName || sku" id="page-title"><span>{{ productName }}</span> - ({{sku}})</h2><span property="dc:title"
          content="Vodafone MachineLink 3G" class="rdf-meta element-hidden"></span>
        <img
          *ngIf="productThumnail"
          loading="lazy"
          decoding="async"
          [src]="productThumnail"
          width="446"
          height="310"
          [attr.alt]="(productName || 'Product') + (sku ? ' (' + sku + ')' : '') + ' image'"
          (error)="onProductImageError($event)"
        >
        <div class="product-marketing-description__label" *ngIf="productDesc">
          Product Marketing Description:
          <app-tooltip-info
            text="This description is shown publicly on the tenant resource centre."
            ariaLabel="Product Marketing Description information"
          ></app-tooltip-info>
        </div>
        <app-render-markdown [markdownData]="productDesc" />
      </div>
      <div id="downloads" class="col col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <div class="row">
          <div class="col col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <ng-container *ngFor="let g of leftList; trackBy: trackById" >
              <app-expansion-pannels [group]="g" />
            </ng-container>
          </div>
          <div class="col col-lg-6 col-md-6 col-sm-12 col-xs-12" style="margin-right: 0px !important;">
            <ng-container *ngFor="let g of rightList; trackBy: trackById">
              <app-expansion-pannels  [group]="g" />
            </ng-container>
          </div>
        </div>
      </div>
    </div>

  </div>
</ng-container>

<ng-template #productNotFound>
  <app-page-not-found></app-page-not-found>
</ng-template>
